import { IIconProps } from "."

export default function PlusIcon(props: IIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" {...props}>
      <path d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
    </svg>
  )
}
